<template>
    <f-dialog
        v-if         = "contact"
        v-model      = "value"
        :width       = "1300"
        :show-delete = "false"
        :show-header = "false"
        @cancel      = "onCancel"
        @store       = "onSave"
    >
        <template v-slot:content>
            <v-form ref="form">
                <v-row class="no-frame mt-3 pl-1">
                    <v-col class="no-frame pr-1 col-4" style="display: flex; flex-direction: column">
                        <v-row class="no-frame" >
                            <v-col class="no-frame col-12">
                                <c-column-header class="primary mb-1" label="Kontakt" />
                                <div class="  lm-border pa-3" style="height: 426px;">
                                    <v-row class="no-frame">
                                        <v-col class="no-frame pr-2 col-4">
                                            <f-enum-select
                                                v-model      = "contact.salutation"
                                                label        = "Anrede"
                                                module       = "msd"
                                                type         = "salutation"
                                            />
                                        </v-col>
                                        <v-col class="no-frame pl-2">
                                            <f-enum-select
                                                v-model      = "contact.status"
                                                label        = "Status"
                                                module       = "msd"
                                                type         = "contactStatus"
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row class="no-frame" v-if="!isPerson">
                                        <v-col class="no-frame">
                                            <v-text-field
                                                label          = "Name"
                                                v-model        = "contact.name"
                                                :rules         = "[requiredRule]"
                                                autocomplete   = "off"
                                                autocorrect    = "off"
                                                autocapitalize = "off"
                                                spellcheck     = "false"
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row class="no-frame" v-if="isPerson">
                                        <v-col class="no-frame pr-2 col-4">
                                            <v-text-field
                                                label          = "Vorname"
                                                v-model        = "contact.firstname"
                                                autocomplete   = "off"
                                                autocorrect    = "off"
                                                autocapitalize = "off"
                                                spellcheck     = "false"
                                            />
                                        </v-col>
                                        <v-col class="no-frame pl-2">
                                            <v-text-field
                                                label          = "Name"
                                                v-model        = "contact.name"
                                                :rules         = "[requiredRule]"
                                                autocomplete   = "off"
                                                autocorrect    = "off"
                                                autocapitalize = "off"
                                                spellcheck     = "false"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="no-frame" v-if="mode === 'customer'">
                                        <v-radio-group
                                            v-model   = "customerContactType"
                                            class     = "ma-0 mt-1 mb-2"
                                            hide-details
                                            dense
                                        >
                                            <v-radio
                                                :ripple = "false"
                                                class   = "mt-0 pt-0 ma-0 w-100"
                                                @click  = "onContactType"
                                                value   = "customer"
                                                color   = "primary"
                                                hide-details
                                            >
                                                <template v-slot:label>
                                                    <span class="primary white--text pa-1 pl-2 pr-2 w-100" style="border-radius: 4px;">Ansprechpartner beim Kunden</span>
                                                </template>
                                            </v-radio>

                                            <v-radio
                                                :ripple = "false"
                                                class   = "mt-2 pt-0 ma-0 w-100"
                                                @click  = "onContactType"
                                                color   = "primary"
                                                value   = "onsite"
                                                hide-details
                                            >
                                                <template v-slot:label>
                                                    <span class="primary white--text pa-1 pl-2 pr-2 w-100" style="border-radius: 4px;">Ansprechpartner vor Ort</span>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-row>

                                    <v-row class="no-frame" v-if="!isOnsite">
                                        <v-col class="no-frame">
                                            <v-select
                                                :items     = "roles"
                                                item-value = "id"
                                                item-text  = "name"
                                                label      = "Rolle"
                                                return-object
                                                :rules         = "[requiredRule]"
                                                v-model    = "contact.roles"
                                                multiple
                                            >
                                                <template v-slot:selection="{ item, index }">
                                                    <div class="v-flex">
                                                        <div v-if="index === 0">{{ item.name }}</div>
                                                        <div
                                                            v-if="index === 1"
                                                            class="grey--text text-caption ml-1"
                                                        >
                                                            {{ '(+' + (contact.roles.length - 1) + ' weitere)'}}
                                                        </div>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row class="no-frame">
                                        <v-col class="no-frame">
                                            <v-textarea
                                                class          = "pt-0"
                                                v-model        = "contact.comment"
                                                rows           = "4"
                                                autocomplete   = "off"
                                                autocorrect    = "off"
                                                autocapitalize = "off"
                                                spellcheck     = "false"
                                                no-resize
                                                hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="no-frame mt-2">
                            <c-column-header class="primary mb-1" label="Zuständig für ..." >
                                <template v-slot:filter>
                                    <div class="pr-6">
                                        <v-icon size="20" color="white">mdi-card-account-mail</v-icon>
                                        <v-icon size="20" class="pl-3" color="white">mdi-card-account-mail-outline</v-icon>
                                    </div>
                                </template>
                            </c-column-header>

                            <div class="lm-border pa-3 pt-0" :key="refreshResponsibilities" >
                                <div class="mr-0 pt-2" style="display: flex; flex-wrap: wrap; flex-direction: column; margin-top: -3px">
                                    <contact-responsiblity
                                        v-for    = "(item, index) in resonsibilities" :key="index"
                                        :item    = "item"
                                        style    = "flex-grow: 1; width: 100%"
                                        @changed = "onChanged"
                                    />
                                </div>
                                <v-divider class="mt-5 mb-5" />
                                <div>
                                    <v-select
                                        v-if           = "incidentTypes"
                                        :items         = "incidentTypes"
                                        item-value     = "id"
                                        item-text      = "name"
                                        label         = "Bei Ereignis"
                                        v-model        = "contact.incidenttypes"
                                        :return-object = true
                                        :multiple      = "true"
                                        :clearable     = "false"
                                        class="mb-2"
                                        hide-details
                                        chips
                                    >
                                        <template v-slot:selection="data">
                                            <v-chip
                                                v-if="data.index < 3"
                                                @click:close = "onRemoveIncidentType(data.item)"
                                                color=       "primary"
                                                style="margin: 1px"
                                                small
                                                close
                                                close-icon="mdi-close"
                                            >
                                                <div class="pl-1">
                                                    <div class="selected-incidenttype">
                                                        {{ data.item.name }}
                                                    </div>
                                                </div>
                                            </v-chip>
                                            <span
                                                v-if="data.index === maxIncidentTypes && contact.incidenttypes.length > maxIncidentTypes"
                                                class="selected-incidenttype-others"
                                            >
                                                (+ {{ contact.incidenttypes.length - maxIncidentTypes }} weitere)
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col class="no-frame pl-1 col-4">
                        <v-row class="no-frame">
                            <v-col class="no-frame col-12">
                                <c-column-header class="primary mb-1" label="Anlagenzuordnung" />
                                <div class="lm-border pa-3" style="height: 170px">
                                    <v-row class="no-frame">
                                        <v-col class="no-frame">
                                            <f-enum-select
                                                v-model      = "contact.siteAssignmentType"
                                                label        = "Anlagenzuordnung"
                                                module       = "msd"
                                                type         = "contactSiteAssignmentType"
                                                :readonly    = "isOnsite"
                                                :exclude     = "isCustomer ? [ 3 ] : []"
                                            />

                                        </v-col>
                                    </v-row>
                                    <v-row class="no-frame" v-if="contact.siteAssignmentType && contact.siteAssignmentType.id === 3">
                                        <v-col class="no-frame">
                                            <c-customer-select
                                                v-model     = "contact.customer"
                                                label      = "Kunde"
                                                :lim-customer = "true"
                                                :rules      = "[requiredRule]"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="no-frame" v-if="!contact.siteAssignmentType || contact.siteAssignmentType.id !== 3">
                                        <v-col class="no-frame">
                                            <v-text-field
                                                label          = "Kennzeichen"
                                                v-model        = "contact.tags"
                                                autocomplete   = "off"
                                                autocorrect    = "off"
                                                autocapitalize = "off"
                                                spellcheck     = "false"
                                            />
                                        </v-col>
                                    </v-row>
                                </div>

                                <c-column-header class="primary mb-1 mt-2" label="Email, Telefon" />


                                <f-phone-numbers
                                    v-model = "contact.phonenumbers" style="height: 555px"
                                >
                                    <template v-slot:pre>
                                        <v-text-field
                                            label="Email"
                                            v-model        = "contact.email"
                                            :rules         = "[requiredNotHotlineRule]"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                            class          = "mt-3 mb-4"
                                        />
                                    </template>
                                </f-phone-numbers>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="no-frame pl-2 col-4">
                        <!-- Service Contact -->
                        <v-row
                            class = "no-frame"
                        >
                            <v-col class="no-frame col-12">
                                <c-column-header
                                    label = "Unternehmen"
                                    class = "primary"
                                />
                                <div class="lm-border pa-3 mt-1" style="height: calc(100% - 34px)">
                                    <v-row class="no-frame" v-if="isCustomer && !isOnsite">
                                        <v-col class="no-frame">
                                            <v-switch
                                                v-model = "customerContact"
                                                label   = "direkt beim Kunden"
                                                class   = "mt-2 mb-3"
                                                dense
                                                hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="no-frame"  v-if="!isOnsite">
                                        <v-col class="no-frame">
                                            <v-autocomplete
                                                v-if           = "companies"
                                                :items         = "companies"
                                                item-value     = "id"
                                                item-text      = "name"
                                                label          = "Auswahl"
                                                v-model        = "contact.company"
                                                :return-object = true
                                                @change        = "onCompany"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        v-if  = "!isUnknowCompany"
                                        class = "no-frame col-12"
                                    >
                                        <div class="primary--text">Adresse</div>
                                        <company-card
                                            v-if     = "contact && contact.company"
                                            :company = "contact.company"
                                            class    = "mt-1 w-100"
                                        />
                                    </v-row>
                                    <c-v-spacer />
                                </div>
                            </v-col>
                        </v-row>
                        <!-- Service Contact -->

                        <div class="lm-border mt-2 pa-3" style="height: calc(100% - 254px)" v-if="!isAdmin">
                        </div>

                        <c-column-header
                            label = "Informationen"
                            class = "primary mt-2"
                        />
                        <div class="lm-border mt-1 pa-3" style="height: calc(100% - 288px)" v-if="isAdmin">
                            <v-row class="no-frame " >
                                <v-col class="no-frame">
                                    Erstellt von / am
                                </v-col>
                                <v-col class="no-frame">
                                    {{ contact.createdBy }}
                                </v-col>
                            </v-row>
                            <v-row class="no-frame " >
                                <v-col class="no-frame">
                                    Erstellt am
                                </v-col>
                                <v-col class="no-frame">
                                    {{ formatDateTime (contact.createdDate) }}
                                </v-col>
                            </v-row>
                            <v-row class="no-frame mt-4" >
                                <v-col class="no-frame">
                                    Zuletzt bearbeitet von
                                </v-col>
                                <v-col class="no-frame">
                                    {{ contact.modifiedBy }}
                                </v-col>
                            </v-row>
                            <v-row class="no-frame" >
                                <v-col class="no-frame">
                                    Zuletzt bearbeitet am
                                </v-col>
                                <v-col class="no-frame">
                                    {{ formatDateTime (contact.modifiedDate) }}
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </template>
    </f-dialog>
</template>

<script>

import Core                 from "@/modules/core/service/Core";
import Customer             from "@/modules/msd/company/customer/service/Customer";
import Company              from "@/modules/msd/company/common/service/Company";
import Contact              from "@/modules/msd/company/contact/service/Contact";
import FDialog              from "@/modules/core/components/utils/FDialog";
import FPhoneNumbers        from "@/modules/msd/common/components/FPhoneNumbers";
import CColumnHeader        from "@/modules/core/components/utils/CColumnHeader";
import ContactResponsiblity from "@/modules/msd/company/contact/components/controlls/ContactResponsiblity";
import FEnumSelect          from "@/modules/core/components/utils/FEnumSelect";
import CVSpacer             from "@/modules/core/components/utils/CVSpacer";
import CompanyCard          from "@/modules/msd/company/common/components/controlls/CompanyCard";
import CCustomerSelect      from "@/modules/msd/company/customer/components/controlls/CCustomerSelect";

export default {
    name: "DContactEdit",
    components: {
        CCustomerSelect,
        CompanyCard,
        CVSpacer,
        FEnumSelect,
        ContactResponsiblity,
        CColumnHeader,
        FPhoneNumbers,
        FDialog
    },

    props: {
        value: {
            required: false,
            type    : Boolean,
        },

        contactId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },

        companyId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },

        customerId: {
            required: false,
            type: Number,
            default: function () {
                return null;
            }
        },

        mode: {
            required: false,
            type    : String,
            default : () => {
                return null;
            }
        }
    },


    data: () => ({
        customerContactType : "customer",
        contact  : {
            allresponsibilities: null,
            phonenumbers       : null,
            email              : null,
            siteAssignmentType : null,
            siteRestriction    : null,
            salutation         : null,
            maxIncidentTypes   : 3
        },
        refreshResponsibilities: 0,
        maxIncidentTypes       : 3,
        companies              : null,
        managers               : [],
        customerContact        : false,
        service           : [
            "FCM",
            "MNT",
            "EMC",
            "MNU",
            "ENT",
            "PM",
            "AU",
            "NC",
            "MF"
        ],
        zus: [
            "ZUS"
        ]
    }),

    watch: {
        value () {
            if (this.value) {
                this.initialize();
            }
        },
    },

    computed: {
        requiredRule () {
            return Core.rule.required;
        },

        isHotline () {
            if (!this.contact.roles) {
                return false;
            }

            return this.contact.roles.find (role => role.id === 8);
        },

        requiredNotHotlineRule () {
            if (this.isHotline) {
                return true;
            }

            return Core.rule.required;
        },

        isPerson () {
            if (!this.contact.salutation) {
                return true;
            }

            return this.contact.salutation.id !== 6 && this.contact.salutation.id !== 5;
        },

        isCustomer () {
            return this.customerContactType && this.customerContactType === "customer";
        },

        isOnsite () {
            return this.customerContactType && this.customerContactType === "onsite";
        },

        isZus () {
            if (!this.contact || !this.contact.company) {
                return false;
            }

            return !!this.contact.company.roles.find(r => r.id === Company.roles.inspection);
        },

        incidentTypes () {
            return this.$store.getters.msd["contactIncidentTypes"];
        },

        resonsibilities () {
            return this.contact.allresponsibilities;
        },

        isUnknowCompany () {
            if (!this.contact || !this.contact.company) {
                return false;
            }

            return this.contact.company.id === Company.unknown;
        },

        roles () {
            if (!this.contact || !this.contact.company) {
                return [];
            }

            const contactRoles = this.$store.getters.msd["contactRoles"];
            const companyRoles = this.contact.company.roles;
            let   roles        = [];

            companyRoles.forEach (role => {
                let roleId = role.id;
                switch (role.id) {
                    case Company.roles.execution    : roleId = Company.roles.maintenance; break;
                    case Company.roles.facilityAdmin: roleId = Company.roles.customer; break;
                    case Company.roles.customercompany: roleId = Company.roles.customer; break;
                }

                const list = contactRoles[roleId];
                if (list) {
                    roles = [...roles, ...list];
                }
            });

            return roles;
        },

        isAdmin () {
            return Core.role.masterdata();
        },

        assignmentType () {
            if (!this.contact) {
                return null;
            }

            return this.contact.siteAssignmentType;
        }
    },

    methods: {
        initialize () {
            if (!this.contactId) {
                return;
            }

            if (this.contactId < 0) {
                Contact.create(this.companyId, (data) => {
                    this.contact = data;
                    this.initializeCustomer();
                    this.refreshResponsibilities ++;
                    this.$emit("initialized", this.contact);
                    this.$refs.form.validate ();
                })

                return;
            }

            Contact.findById(this.contactId, (data) => {
                this.contact = data;
                this.initializeCustomer();
                this.refreshResponsibilities ++;
                this.$emit("initialized", this.contact);
                this.$refs.form.validate ();
            });
        },

        reloadCompanies () {
            switch (this.customerContactType) {
                case "onsite":
                    Company.companiesByRoles([Company.roles.facilitymanagement]).then(data => {
                        this.companies = data;
                    })
                    break;
                case "customer":
                    Customer.companies(this.customerId, (data) => {
                        this.companies = data;
                    });
                    break;
                case "zus":
                    Company.companiesByRoles(this.zus).then(data => {
                        this.companies = data;
                    });
                    break;
                default:
                    Company.companiesByRoles(this.service).then(data => {
                        this.companies = data;
                    })
            }
        },

        onContactType () {
            if (this.customerContactType === "onsite") {
                this.contact.siteAssignmentType = 1;
                Company.get(this.customerId).then (company => {
                    this.contact.company = company;
                });

                this.contact.roles = [ {
                    id: Contact.roles.onsite,
                } ];

                return;
            }

            if (this.customerContactType === "customer") {
                this.contact.roles = [ {
                    id: Contact.roles.customerContact,
                } ];
            }

            this.reloadCompanies();
        },

        onChanged (data) {
            const item = this.contact.allresponsibilities.find (r => r.responsibility.id === data.responsibility.id);

            item.selected = data.selected;
            item.mail = data.mail;
            item.cc = data.cc;
        },

        onDelete () {

        },

        onRemoveIncidentType (item) {
            const index = this.contact.incidenttypes.findIndex(s => s.id === item.id);
            if (index >= 0) {
                this.contact.incidenttypes.splice(index, 1)
            }
        },

        onSave () {
            if (!this.$refs.form.validate ()) {
                return;
            }

            Contact.store(this.contact, (data) => {
                Core.message.alert.save(this);
                Core.fire.saved(this, data);
                this.$emit("input", false);
            })
        },

        onCompany (company) {
            if (!company) {
                const defaultCompany = this.$store.getters.msd ['servicecompanies'].find(c => c.id === 1)
                this.$nextTick(() => {
                    this.contact.company = defaultCompany;
                })
            }
        },

        onCancel () {
            this.$emit("input", false);
        },

        initializeCustomer () {
            if (this.mode === 'customer') {
                if (this.contact.roles.find (role => role.id === 2)) {
                    this.customerContactType = "onsite"
                } else {
                    this.customerContactType = "customer"
                }
            } else {
                if (this.isZus) {
                    this.customerContactType = "zus"
                } else {
                    this.customerContactType = null;
                }
            }

            this.reloadCompanies();
        },

        formatDateTime (value) {
            if (!value) {
                return "---";
            }

            return Core.format.datetime.display(value);
        }
    }
}
</script>

<style scoped>


.selected-incidenttype {
    margin-top: 0;
    width: 130px;
    max-width: 160px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
}

.selected-incidenttype-others {
    font-size: 13px;
    padding-left: 5px;
    margin-top: -2px;
}

::v-deep .theme--light.v-icon:focus:after {
    opacity: 0;
}

::v-deep .v-select__selections {
    margin-top: 4px;
}

</style>